import styled from 'styled-components';

import { color } from '../../../../atoms/colors';
import { font } from '../../../../atoms/typography';
import { atMinWidth } from '../../../../atoms/breakpoints';
import { spacing } from '../../../../atoms/spacing';

import {
  defaultStyles,
  variants,
  sizes,
} from '../../../CallToAction/styles/CallToAction.styled';

export const Container = styled.div`
  position: relative;
  width: 100%;
  max-width: 834px;
  border-radius: ${spacing[16]};
  padding-top: ${spacing[8]};
  margin-top: ${spacing[32]};
  border: 1px solid ${color.midnight[100]};
  background: ${color.common.white};
  box-shadow: 0 20px 24px -4px rgba(16, 24, 40, 0.08),
    0 8px 8px -4px rgba(16, 24, 40, 0.03);

  &.loading {
    height: 100%;
    align-items: center;
    justify-content: center;
  }
`;

export const Logo = styled.div`
  position: absolute;
  top: -32px;
  left: 50%;
  transform: translateX(-50%);
  width: 64px;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${spacing[14]};
  border: 1.164px solid ${color.midnight[100]};
  background: ${color.common.white};

  svg {
    width: 46px;
    height: 46px;
  }
`;

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${spacing[16]};
  padding: ${spacing[32]} ${spacing[16]};

  ${atMinWidth.md`
    padding: ${spacing[32]} ${spacing[40]};
  `}
`;

export const Header = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${spacing[12]};

  .heading {
    ${font('display', 'sm', '600')}
    color: ${color.darkBlue[1000]};
    text-align: center;
  }

  .subhead {
    ${font('text', 'md', '400')}
    color: ${color.darkBlue[600]};
    text-align: center;
  }
`;

export const Form = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${spacing[20]};

  /* Hidden Fields */
  & input[name='country'],
  & input[name='state'],
  & input[name='industry'],
  & input[name='industrydetail'],
  & input[name='autofocus'] {
    display: none !important;
  }

  .checkbox-container {
    margin-bottom: ${spacing[20]};
  }

  .disclaimer-checkbox {
    ${font('text', 'sm', '400')}
    color: ${color.grey[700]};
  }
`;

export const TwoColumn = styled.div`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: ${spacing[20]};

  ${atMinWidth.md`
    grid-template-columns: repeat(2, 1fr);
    gap: ${spacing[12]};
`}
`;

export const SignUp = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${spacing[20]};
  padding-top: ${spacing[20]};
  margin-top: ${spacing[4]};
  border-top: 1px solid ${color.midnight[100]};

  .heading {
    ${font('text', 'md', '600')}
    color: ${color.darkBlue[600]};
  }
`;

export const ErrorMessage = styled.div`
  transform: translateY(-10px);
  ${font('text', 'sm', '400')}
  color: ${color.primary[1000]};

  p {
    ${font('text', 'sm', '400')}
    color: ${color.primary[1000]};
  }

  a {
    ${font('text', 'sm', '400')}
    color: ${color.blue[700]};
  }
`;

export const Button = styled.button`
  width: 100%;
  text-align: center;
  transition: all 250ms ease-in-out;
  ${defaultStyles}
  ${sizes.sm}
  ${variants['Filled - Blue']}

  ${atMinWidth.md`
      ${sizes.md}
  `}

   ${atMinWidth.xl`
      ${sizes.lg}
  `}
`;

export const Footer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${spacing[8]};
  p {
    ${font('text', 'xs', '400')}
    color: ${color.darkBlue[700]};
    text-align: center;
  }
  a {
    ${font('text', 'xs', '400')}
    color: ${color.blue[700]};
    &:hover {
      color: ${color.blue[700]};
    }
  }
`;

export const FooterLink = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${spacing[8]};
  p {
    display: flex;
    align-items: center;
    gap: ${spacing[8]};
    ${font('text', 'sm', '500')}
    color: ${color.darkBlue[700]};
    text-align: center;
  }
`;
